export default __webpack_public_path__ + "static/media/lock_alert.cade0713.mp3";